import styled from 'styled-components';

const Container = styled.div`
  h5 {
    display: block;
  }
`;

export default Container;
